import * as vuetify from '@/plugins/vuetify'

export const SMALL_HEIGHT_COMPATIBILITY_BREAKPOINT = 720

function bp () {
  return vuetify.default.framework.breakpoint
}

export function chartArea (isDense = false) {
  const MIN_AREA_ROWS = 4
  const HEIGHT_DIVIDEND = 86
  const smallHeightCompatibility = bp().height < SMALL_HEIGHT_COMPATIBILITY_BREAKPOINT

  let rowSpan = 9
  let columnSpan = 12

  if (isDense) {
    rowSpan = 7
    columnSpan = 8
  }

  if (smallHeightCompatibility) {
    rowSpan = Math.max(MIN_AREA_ROWS, Math.ceil(bp().height / HEIGHT_DIVIDEND))
  }

  return [rowSpan, columnSpan]
}
